import React from 'react'
import PropTypes from 'prop-types'
import { SectionHeader } from 'SectionHeader'

import css from './Page.css'

export const PageContent = ({ children }) => (
  <div className={css.pageContent}>
    {children}
  </div>
)
PageContent.propTypes = {
  children: PropTypes.element.isRequired,
}

export const PageHeader = (props) => <SectionHeader {...props} type="page" />
